module.exports = __webpack_public_path__ + "media/images/sp/brands/aqua/store_tachikawa-e6ceadb58dc51942875f68eb3df845c6.jpg";